import React from 'react';
import { Button, ButtonProps } from './Button';

export interface AuthButtonProps extends ButtonProps {
  /** 
   * Module and action for permission check (optional, if using external permission check)
   */
  module?: string;
  action?: string;
  
  /** 
   * Cờ xác định xem user có quyền thực hiện không. 
   * Nếu false: Nút bị disabled và hiện Tooltip lý do. 
   */
  hasPermission?: boolean;
  
  /** 
   * Lý do hiện lên tooltip nếu không có quyền (Mặc định: Bạn không có quyền thực hiện hành động này)
   */
  unauthorizedMessage?: string;
}

/**
 * AuthButton - Wrapper thông minh cho Button (Chuẩn UX DNA #10)
 * Tự động vô hiệu hóa và hiển thị Tooltip nếu User không có quyền, thay vì ẩn giấu đi một cách khó hiểu.
 */
export const AuthButton = React.forwardRef<HTMLButtonElement, AuthButtonProps>(
  ({ 
    hasPermission = true, 
    module, 
    action, 
    unauthorizedMessage = 'Bạn không có quyền thực hiện hành động này', 
    className = '', 
    ...props 
  }, ref) => {
    
    if (!hasPermission) {
      return (
        <div className={`relative inline-block group ${className}`}>
          {/* Nút đã bị vô hiệu hóa */}
          <Button {...props} disabled={true} className="w-full" />
          
          {/* Tooltip đen ngầu nổi lên khi hover */}
          <div className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 w-max px-3 py-1.5 bg-os-text text-os-canvas text-xs font-medium rounded-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all z-50 pointer-events-none">
            {unauthorizedMessage}
            {/* Tam giác chóp của Tooltip */}
            <div className="absolute top-full left-1/2 -translate-x-1/2 border-4 border-transparent border-t-os-text" />
          </div>
        </div>
      );
    }

    // Nếu có quyền, render Button bình thường
    return <Button ref={ref} className={className} {...props} />;
  }
);

AuthButton.displayName = 'AuthButton';
